import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'

import FormatUtils from '@front/squirtle/utils/format'
import { TextCell } from '@abra/elements/table/cells/basics/'
import { DriverLink, VehicleLink, LicenseLink, StaffLink, GroupLink } from '@abra/elements'

const Row = ({ row }) =>
  <>
    <TableCell>
      <TextCell value={FormatUtils.formatDateBackToFront(row?.createdAt, 'DD/MM/YY HH[h]mm')} variant='small' />
    </TableCell>
    <TableCell>
      <StaffLink record_id={row?.operator} hidden={!row?.operator} />
    </TableCell>
    <TableCell>
      <DriverLink record_id={row?.driver} hidden={!row?.driver} />
    </TableCell>
    <TableCell>
      <VehicleLink record_id={row?.vehicle} hidden={!row?.vehicle} />
    </TableCell>
    <TableCell>
      <GroupLink record_id={row?.group} hidden={!row?.group} />
    </TableCell>
    <TableCell>
      <LicenseLink record_id={row?.license} hidden={!row?.license} />
    </TableCell>
    <TableCell>
      <TextCell value={I18n.t(`event.${row?.name}`)} variant='small' />
    </TableCell>
    <TableCell>
      <TextCell value={row?.infos} />
    </TableCell>
  </>

export default React.memo(Row)
